export const colors = {
  blue: '#333',
  buttonMantineDefaultColor: 'rgba(53, 149, 219, 1)',
}
